module.exports = __webpack_public_path__ + "img/chevron-down-alt.7f75c417.svg";